import { RailsThumbnailItem } from '@sls-react/typings/services/rails/item';
import { useQuery } from 'react-query';
import { fetchFacetUserMeta } from '@sls-react/api/items';
import { useSession } from '@sls-react/contexts/SessionContext';
import { minutes5inMS } from '../constants/times';
import { RailsFlattenedFacetQuery } from '@sls-react/typings/services/rails/facets';

export default function useItemGridMeta(
  items?: RailsThumbnailItem[],
  additionalContext?: RailsFlattenedFacetQuery,
) {
  const ids = items?.map(i => i.id);
  useQuery(
    ['item-meta', ids, additionalContext],
    () => fetchFacetUserMeta(ids!, additionalContext),
    {
      enabled: !!ids,
      staleTime: minutes5inMS,
    },
  );
}
